module.exports = __webpack_public_path__ + "static/fonts/CoTextCorp-Light.a1e236e.woff2";